"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

import { useAuth } from "@/contexts/auth-context";
import { usePageTitle } from "@/hooks/use-page-title";

export default function Home() {
  const { isAuthenticated, isLoading } = useAuth();
  const router = useRouter();

  // Set page title
  usePageTitle("Reservation System", undefined, false);

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        // Redirect to dashboard if authenticated
        router.push("/dashboard");
      } else {
        // Redirect to login if not authenticated
        router.push("/login");
      }
    }
  }, [isAuthenticated, isLoading, router]);


}
